import { render, staticRenderFns } from "./FailedPayment.vue?vue&type=template&id=36032270&"
import script from "./FailedPayment.vue?vue&type=script&lang=js&"
export * from "./FailedPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports